import { render, staticRenderFns } from "./PageIns.vue?vue&type=template&id=478af78b&scoped=true&"
import script from "./PageIns.vue?vue&type=script&lang=js&"
export * from "./PageIns.vue?vue&type=script&lang=js&"
import style0 from "./PageIns.vue?vue&type=style&index=0&id=478af78b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478af78b",
  null
  
)

export default component.exports